import Axios from '~/utils/axios';
import { useQuery } from 'react-query';
import { sentryCaptureException } from '~/errors/sentry';
type BookingsListProps = {
   searchTerm?: string[] | null;
   statusFilter?: string[] | null;
   pageNumber?: number | null;
   endDate?: string | null;
   startDate?: string | null;
   per_page?: number;
   product?: string | string[];
   time?: string | null;
   date?: string | null;
   sort?: string;
   venue_visibility?: string;
};
const useBookingsList = ({
   searchTerm,
   statusFilter,
   pageNumber,
   startDate,
   endDate,
   product,
   time,
   date,
   per_page,
   sort = 'date_desc',
   venue_visibility,
}: BookingsListProps) => {
   const getBookingsList = async ({ queryKey }: any) => {
      const {
         statusFilter,
         searchTerm,
         startDate,
         endDate,
         product,
         time,
         date,
         per_page,
         sort,
         venue_visibility,
      } = queryKey[1];
      const { data } = await Axios.get(`/hy-providers/v1/bookings`, {
         params: {
            keyword: searchTerm,
            status: statusFilter && `${statusFilter}`,
            page: pageNumber,
            per_page: per_page || 10,
            from_date: startDate,
            to_date: endDate,
            product: product,
            date_or_time: date,
            time_filter: time,
            sort: sort,
            venue_visibility,
         },
      });
      return data;
   };

   return useQuery(
      [
         'bookings-list',
         {
            searchTerm,
            statusFilter,
            pageNumber,
            endDate,
            startDate,
            per_page,
            product,
            date,
            time,
            sort,
            venue_visibility,
         },
      ],
      getBookingsList,
      {
         refetchOnWindowFocus: false,
         onError: (error: Error) => {
            sentryCaptureException(error, { tags: { journey: 'business' } });
         },
      }
   );
};
export default useBookingsList;
